import { render } from "./App.vue?vue&type=template&id=e97ae582"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=e97ae582&lang=css"

import exportComponent from "C:\\projetos\\andamento-da-obra\\client-EN\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__